// extracted by mini-css-extract-plugin
export default {"aside__wrapper":"style_aside__wrapper__DOn1q","user_info":"style_user_info__ErNOe"};